/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevokeTokenReq
 */
export interface RevokeTokenReq {
    /**
     * A JWT token. Can be either a User token (`UserTokenText`) or a Token Container (`TokenContainerText`)
     * @type {string}
     * @memberof RevokeTokenReq
     */
    token: string;
}

/**
 * Check if a given object implements the RevokeTokenReq interface.
 */
export function instanceOfRevokeTokenReq(value: object): value is RevokeTokenReq {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function RevokeTokenReqFromJSON(json: any): RevokeTokenReq {
    return RevokeTokenReqFromJSONTyped(json, false);
}

export function RevokeTokenReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevokeTokenReq {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function RevokeTokenReqToJSON(json: any): RevokeTokenReq {
    return RevokeTokenReqToJSONTyped(json, false);
}

export function RevokeTokenReqToJSONTyped(value?: RevokeTokenReq | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

